module.exports = __webpack_public_path__ + "img/vertical_3_6_1.7f695f5c.png";